/* eslint-disable import/prefer-default-export */

export const gatherCategories = (data) => {
  const categoryArr = [];
  data.forEach((item) => {
    if (item.data.Warcrime_Category) {
      item.data.Warcrime_Category.forEach((category) => {
        const categoryObj = {
          label: category,
          slug: category.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''),
          count: 0,
        };
        if (categoryArr.filter((e) => e.slug === categoryObj.slug).length === 0) {
          categoryArr.push(categoryObj);
        }
      });
    }
  });
  const sortedCategories = categoryArr.sort((a, b) => ((b.slug < a.slug) ? 1 : -1));
  return sortedCategories;
};

export const gatherFacets = (data) => {
  const facetArr = [];
  data.forEach((item) => {
    if (item.data.Warcrime_Facet) {
      item.data.Warcrime_Facet.forEach((facet) => {
        const facetObj = {
          label: facet,
          slug: facet.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''),
          count: 0,
        };
        if (facetArr.filter((e) => e.slug === facetObj.slug).length === 0) {
          facetArr.push(facetObj);
        }
      });
    }
  });
  const sortedFacets = facetArr.sort((a, b) => ((b.slug < a.slug) ? 1 : -1));
  return sortedFacets;
};
